// Identificadores que dependen de la cuenta de Bitrix24.
//
// Cuenta actual: sfusagroup.bitrix24.com
//   - Los deals de Parnerus viven en el embudo 33 ("Parnerus"), no en el general.
//   - Las facturas del smart process (entityTypeId 31) viven en la categoria 1.
//
// Al mudarse de cuenta o de embudo, esto es lo unico que hay que tocar.

export const DEAL_CATEGORY_ID = 33;
export const SMART_INVOICE_CATEGORY_ID = 1;

/** Campo "Business" de la cuenta nueva: marca a que unidad de negocio pertenece
 *  el registro. Todo lo de Parnerus se crea con este valor. */
export const CONTACT_BUSINESS_FIELD = "UF_CRM_69CE81A502F5A";

/** Origen del contacto, lista propia de Parnerus. La lista NATIVA de Bitrix
 *  (SOURCE) es de SF USA Group y no sirve para los usuarios de Parnerus. */
export const PARNERUS_SOURCE_FIELD = "UF_CRM_PARNERUS_SOURCE";

/** Nombre de la cuenta de Parnerus en la empresa. */
export const COMPANY_ACCOUNT_NAME_FIELD = "UF_CRM_PARNERUS_ACCOUNT_NAME";

/** First Contact de la empresa: el Mediador de la cuenta. Ojo, hay DOS campos
 *  llamados asi; el que usa el equipo y escribe el business process es este,
 *  el multiple, no el simple UF_CRM_69CE81A57C15A. */
export const COMPANY_FIRST_CONTACT_FIELD = "UF_CRM_1650412445";
export const COMPANY_BUSINESS_FIELD = "UF_CRM_69CE81A5AE48D";
export const DEAL_BUSINESS_FIELD = "UF_CRM_69CE81A6124B2";
export const CONTACT_BUSINESS_PARNERUS = "837";
export const COMPANY_BUSINESS_PARNERUS = "847";
export const DEAL_BUSINESS_PARNERUS = "857";

/** ENTITY_ID que se le pide a crm.status.list. Cambia con la categoria. */
export const STATUS_ENTITY_ID = {
  DEAL_STAGE: `DEAL_STAGE_${DEAL_CATEGORY_ID}`,
  SMART_INVOICE_STAGE: `SMART_INVOICE_STAGE_${SMART_INVOICE_CATEGORY_ID}`,
  DEAL_TYPE: "DEAL_TYPE",
  SOURCE: "SOURCE",
  INDUSTRY: "INDUSTRY",
} as const;

/** Clave logica con la que la app busca cada lista dentro de `listFields`.
 *  Es estable: no lleva el numero de categoria para que no haya que tocarla. */
export const LIST_KEY = {
  DEAL_STAGE: "DEAL_STAGE",
  SMART_INVOICE_STAGE: "SMART_INVOICE_STAGE",
  DEAL_TYPE: "DEAL_TYPE",
  SOURCE: "SOURCE",
  INDUSTRY: "INDUSTRY",
} as const;

/** Version del cache de localStorage. Subir esto invalida las listas cacheadas
 *  de TODOS los usuarios, sin que tengan que limpiar el navegador a mano.
 *  Subir cada vez que cambien los IDs de campo, de lista o de embudo. */
export const BITRIX_CACHE_VERSION = "v3-parnerus-source";

export const CACHE_KEY = {
  listFields: `listFields.${BITRIX_CACHE_VERSION}`,
  productsList: `productsList.${BITRIX_CACHE_VERSION}`,
  userfieldList: `userfieldList.${BITRIX_CACHE_VERSION}`,
} as const;

/** Claves de versiones anteriores, que se borran al iniciar para no dejar basura. */
export const LEGACY_CACHE_KEYS = [
  "listFields",
  "productsList",
  "userfieldList",
];

/** Formularios CRM embebidos. Son propios de cada portal: los IDs no son
 *  portables entre cuentas, hay que recrearlos y actualizar esto. */
export const BITRIX_PORTAL_ID = "b17791713";

export const CRM_FORMS = {
  /** Soporte Tecnico. Lo usan TechnicalSupportPage e InfoPage. */
  technicalSupport: { id: "inline/45/4tyilf", loader: "loader_45" },
  /** Soporte Contable. */
  accountingSupport: { id: "inline/43/bpwtto", loader: "loader_43" },
  /** Solicitud de baja de cuenta. */
  deleteAccount: { id: "inline/47/pjde9d", loader: "loader_47" },
} as const;

export function crmFormScript(form: { id: string; loader: string }) {
  return `(function(w,d,u){
    var s=d.createElement('script');s.async=true;s.src=u+'?'+(Date.now()/180000|0);
    var h=d.getElementsByTagName('script')[0];h.parentNode.insertBefore(s,h);
    })(window,document,'https://cdn.bitrix24.com/${BITRIX_PORTAL_ID}/crm/form/${form.loader}.js');`;
}
